import type { AppointmentStatus } from '@bcl/shared';

export const appointmentStatusBadge: Record<
  AppointmentStatus,
  { label: string; cls: string }
> = {
  demande: { label: 'Demande', cls: 'bg-gray-100 text-gray-700' },
  creneaux_proposes: { label: 'Créneaux proposés', cls: 'bg-blue-100 text-blue-800' },
  confirme: { label: 'Confirmé', cls: 'bg-indigo-100 text-indigo-800' },
  attribue: { label: 'Attribué', cls: 'bg-amber-100 text-amber-800' },
  accepte: { label: 'Accepté', cls: 'bg-teal-100 text-teal-800' },
  refuse: { label: 'Refusé', cls: 'bg-red-100 text-red-800' },
  realise: { label: 'Réalisé', cls: 'bg-green-100 text-green-800' },
  non_effectue: { label: 'Non effectué', cls: 'bg-orange-100 text-orange-800' },
};

export function formatSlot(iso: string | null): string {
  if (!iso) return '—';
  return new Date(iso).toLocaleString('fr-FR', {
    dateStyle: 'medium',
    timeStyle: 'short',
  });
}
